import templateUrl from "./profile-edit.html";

export const profileEditComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,
  controller: class ProfileEditComponent {
    constructor(
      $state,
      $stateParams,
      $cookies,
      toastr,
      Constants,
      ProfileService
    ) {
      "ngInject";

      this.$state = $state;
      this.Constants = Constants;
      this.$stateParams = $stateParams;
      this.$cookies = $cookies;
      this.profileService = ProfileService;
      this.toastr = toastr;
    }
    $onInit() {
      this.disableButtons = false;
      this.phoneNumberDetails = {
        phoneNumber: this.details.phoneNumber,
        phoneCountryCode: this.details.phoneNumber
          ? this.details.phoneCountryCode
          : "US",
        phoneDialCode: this.details.phoneNumber
          ? this.details.phoneDialCode
          : "+1",
      };
    }

    onCancel() {
      this.$state.go("profileDetail", this.$stateParams);
    }

    onPhoneNumberUpdate(details) {
      this.details.phoneNumber = details.phoneNumber || "";
      this.details.phoneCountryCode = details.phoneNumber
        ? details.phoneCountryCode
        : "";
      this.details.phoneDialCode = details.phoneNumber
        ? details.phoneDialCode
        : "";
    }

    onSubmit() {
      this.profileService
        .updateProfileDetails({
          firstName: this.details.firstName,
          lastName: this.details.lastName,
          militaryEmail: this.details.militaryEmail,
          unitIdentificationCode: this.details.unitIdentificationCode,
          nameOfCommand: this.details.nameOfCommand,
          phoneCountryCode: this.details.phoneNumber
            ? this.details.phoneCountryCode
            : "",
          phoneDialCode: this.details.phoneNumber
            ? this.details.phoneDialCode
            : "",
          phoneNumber: this.details.phoneNumber ? this.details.phoneNumber : "",
        })
        .then((_) => {
          this.toastr.success("Profile updated successfully.");
          // update the user firstName and nameOfCommand to cookies
          // this information is shown in the header and is picked
          // from the cookies
          const cache = this.$cookies.getObject("user");
          cache.firstName = this.details.firstName;
          cache.name = this.details.firstName;
          cache.nameOfCommand = this.details.nameOfCommand;
          this.$cookies.putObject("user", cache);
          // reload the page, for the information to get updated from cookies
          // presently there is no other way than to reload the page
          this.$state.go(
            "profileDetail",
            { id: this.$stateParams.id },
            { reload: true }
          );
        })
        .catch((err) => {
          this.toastr.error(err);
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-edit/profile-edit.component.js